import React from 'react';

import { ThemeMode } from '@swf/core/enums';

import useThemeMode from '../../hooks/useThemeMode';

import UIStateSwitch from './UIStateSwitch';
import MoonIcon from './assets/moon-icon.svg';
import SunIcon from './assets/sun-icon.svg';

interface ThemeStatus {
  name: string;
  icon: React.FC<React.SVGAttributes<SVGElement>>;
  id: ThemeMode;
  action: string;
}

export const states: ThemeStatus[] = [
  {
    name: 'Dark Mode',
    icon: MoonIcon,
    id: ThemeMode.Dark,
    action: 'enable'
  },
  {
    name: 'Light Mode',
    icon: SunIcon,
    id: ThemeMode.Light,
    action: 'disable'
  }
];

export const ThemeModeSwitch: React.FC = () => {
  const { darkMode } = useThemeMode();
  const handleChange = (id: string) => {
    const state: ThemeStatus | undefined = states.find((state) => state.id === id);

    if (!state) return;

    darkMode[state?.action]();
  };

  const active = darkMode.value ? ThemeMode.Dark : ThemeMode.Light;

  return <UIStateSwitch active={active} states={states} onChange={handleChange} />;
};

export default ThemeModeSwitch;
